import React, { useEffect, useState } from "react";
import Form from "./Form";
import { postRequest, request } from "../../../utils/request";
import { getCategoriasForDropdown, getLink, toast } from "../../../utils/helpers";
import { useHistory } from "../../../utils/router";

const Create = () => {
    const [items, setItems] = useState([]);
    const [categorias, setCategorias] = useState([]);
    const [loadingItems, setLoadingItems] = useState(false);
    const [errors, setErrors] = useState({});
    const history = useHistory();

    const goToGrid = () => history.push(getLink('/productos/inventario-masivo'));

    const create = async (e) => {
        setErrors({});

        const data = new FormData(e.target);

        const response = await postRequest('movimientos', data);

        if (!response.success) {
            setErrors(response.data.message);
            toast('Error creando el ajuste masivo de inventario', 'error');
            return
        }

        toast('Ajuste masivo guardado con éxito');
        goToGrid();
    };

    const getItems = async (url = null) => {
        setLoadingItems(true);

		url = url ? url + "&limit=100000" : "productos?limit=100000";
		const productos = await request(url);

        setItems(productos.data ?? []);
        setLoadingItems(false);
	};

    const getCategorias = () => {
        request("grupos").then((res) => setCategorias([{ value: undefined, label: "Sin Categorías"}, ...res.data.map(item => ({ value: item.id, label: item.nombre}))]));
    };

    useEffect(() => {
        getItems();
        getCategorias();
    }, []);

    return <div className="crear-compra">
        <div className="page-controls">
            <div className="page-header">
                <div className="page-title d-flex">
                    <button className="btn btn-secondary my-auto" onClick={goToGrid}><i className="fas fa-arrow-left"></i></button>
                    <div className="mx-2 d-flex flex-column">
                        <h2 className="m-0 p-0" style={{fontWeight: 500}}>Nuevo ajuste de inventario masivo</h2>
                        <small>Registre los productos y cantidades para realizar el ajuste de inventario</small>
                    </div>
                </div>
            </div>

            <Form items={items} loadingItems={loadingItems} onSave={create} onCancel={goToGrid} errors={errors} categorias={categorias} />
        </div>
    </div>;
};

export default Create;
